<script lang="ts">
	import profile from "@assets/images/profile.png";
	import review1 from "@assets/images/review1.jpeg?webp";
	import review2 from "@assets/images/review2.jpeg?webp";
	import review3 from "@assets/images/review3.jpeg?webp";
	import review4 from "@assets/images/review4.jpeg?webp";
	import review5 from "@assets/images/review5.jpeg?webp";
	import review6 from "@assets/images/review6.jpeg?webp";
	import CarouselWithArrows from "@components/CarouselWithArrows.svelte";
	import Review from "@components/Review.svelte";
	import type { ComponentProps } from "svelte";
	import { getReviewsPath } from "@core/schema/paths/getReviewsPath.js";
	import { getIdFromPath } from "@core/schema/utils/getIdFromPath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const reviews: ComponentProps<typeof Review>[] = [
		{
			image: { src: review1, type: "image/webp" },
			profile: { src: profile, type: "image/png" },
			stars: 5,
			name: "Karel Schöberl",
			description:
				"Přenosné ohniště mě mile překvapilo svou jednoduchostí a kvalitou. Na víkendovém výletě s rodinou jsme ho poprvé vyzkoušeli při večerním posezení. Během pár minut bylo složené bez jakéhokoli nářadí a připravené k rozdělání ohně. Ocenil jsem jak stabilně celé ohniště stojí, i když byl terén nerovný.",
		},
		{
			image: { src: review2, type: "image/webp" },
			profile: { src: profile, type: "image/png" },
			stars: 5,
			name: "Martin Kinzler",
			description:
				"Jako vášnivý zahrádkář jsem hledal ohniště, které bude praktické, bezpečné a nebude mi ničit trávník. Toto ohniště mě mile překvapilo – bez problémů ho přesunu tam, kde potřebuju, a přitom nezabírá místo, když zrovna nepotřebuju oheň. Výborně se mi osvědčilo při spalování suchých větviček a drobného dřeva.",
		},
		{
			name: "Jiří Gurniok",
			image: { src: review3, type: "image/webp" },
			profile: { src: profile, type: "image/png" },
			stars: 5,
			description:
				"Na rybách jsem oheň využil nejen na zahřátí, ale i na ohřev vody i přípravu večeře přímo u vody – výsledek skvělý! Ohniště drží stabilitu i na mírně nerovném břehu a po použití ho stačí otřít. Navíc díky designu mám jistotu, že nezpůsobím žádné nechtěné požáry a příroda zůstane nepoškozená.",
		},
		{
			name: "Karel Levora",
			image: { src: review4, type: "image/webp" },
			profile: { src: profile, type: "image/png" },
			stars: 5,
			description:
				"Často vyrážím na výlety s karavanem, oceňuji u ohniště především to, jak snadno se přepravuje. Ohniště se dá během chvilky složit do pevného plechového obalu, nezabírá moc místa a díky nízké hmotnosti ho zvládne přenést i jedna osoba.",
		},
		{
			name: "Milan Denk",
			image: { src: review5, type: "image/webp" },
			profile: { src: profile, type: "image/png" },
			stars: 5,
			description:
				"Používám ho pravidelně – v kempu, u vody i na zahradě – rychle ho mám rozbalené a připravené k použití. Nepotřebuju žádné nářadí, všechno do sebe jednoduše zapadá. Materiál je pevný a přitom relativně lehký, takže ani časté přesuny ohništi nijak neubírají na životnosti.",
		},
		{
			image: { src: review6, type: "image/webp" },
			profile: { src: profile, type: "image/png" },
			stars: 5,
			name: "Václav Divíšek",
			description:
				"Skvělý parťák na cesty. Přenosné, skladné, a přitom stabilní a odolné – perfektní volba pro každého, kdo chce mít svůj oheň vždy při sobě.",
		},
	];

	const { tenant } = getGlobalTemplateProps();
</script>

<section class="py-12">
	<h2 class="text-center font-bold mb-4" id={getIdFromPath(getReviewsPath(tenant.locale))}>Recenze produktu</h2>
	<p class="h3 max-w-[61rem] mx-auto !text-nov-red-300 text-center mb-12">
		Jak chutná večer s přenosným ohništěm? Takto.
	</p>

	<CarouselWithArrows
		items={reviews}
		itemsContainerClass="*:basis-full md:*:basis-1/2 lg:*:basis-1/3 *:px-3"
		options={{
			slidesToScroll: 1,
			loop: true,
			inViewThreshold: 0.5,
		}}
	>
		{#snippet item(carouselItem)}
			<div class="w-full flex justify-center">
				<Review {...carouselItem} />
			</div>
		{/snippet}
	</CarouselWithArrows>
</section>
